// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 25","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.4102 0.0605469L15.1255 6.23403L22.1449 7.85973L17.4216 13.3009L18.0446 20.4791L11.4102 17.6684L4.77581 20.4791L5.39879 13.3009L0.675537 7.85973L7.69494 6.23403L11.4102 0.0605469ZM20.8631 14.0114L23.338 16.4862L21.9238 17.9004L19.4489 15.4256L20.8631 14.0114ZM12.5663 20.1266L15.0411 22.6015L13.6269 24.0157L11.152 21.5408L12.5663 20.1266ZM19.1444 20.1266L21.6193 22.6015L20.205 24.0157L17.7302 21.5408L19.1444 20.1266Z"}}]};

const Animation1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'animation-1-filled',
    ref,
    icon: element,
  },
));

Animation1FilledIcon.displayName = 'Animation1FilledIcon';

export default Animation1FilledIcon;
